export default "__VITE_ASSET__458676db__"